module.exports = __webpack_public_path__ + "img/A.d48d7a6f.jpg";